export const VEHICLE_HELP_DOMAIN = "vehicle" as const;

export const VEHICLE_HELP_SCREENS = {
  list: "vehicle.list",
  form: "vehicle.form",
  detail: "vehicle.detail",
} as const;

export const VEHICLE_LIST_HELP_KEYS = {
  search: "vehicle.list.search",
  filters: "vehicle.list.filters",
  new: "vehicle.list.new",
  rows: "vehicle.list.rows",
  /** @deprecated Prefer per-action keys; kept for tour fallbacks */
  row: "vehicle.list.row",
  rowActions: "vehicle.list.row_actions",
  actionView: "vehicle.list.action_view",
  actionEdit: "vehicle.list.action_edit",
  actionDelete: "vehicle.list.action_delete",
  actionMerge: "vehicle.list.action_merge",
} as const;

export const VEHICLE_FORM_HELP_KEYS = {
  plate: "vehicle.form.plate",
  secondaryPlate: "vehicle.form.secondary_plate",
  vin: "vehicle.form.vin",
  dealersPlate: "vehicle.form.dealers_plate",
  make: "vehicle.form.make",
  model: "vehicle.form.model",
  state: "vehicle.form.state",
  color: "vehicle.form.color",
  year: "vehicle.form.year",
  submit: "vehicle.form.submit",
} as const;

export const VEHICLE_DETAIL_HELP_KEYS = {
  vehicleInfo: "vehicle.detail.vehicle_info",
  permanentParking: "vehicle.detail.permanent_parking",
  safelistings: "vehicle.detail.safelistings",
  storedVehicles: "vehicle.detail.stored_vehicles",
  citations: "vehicle.detail.citations",
  kpiStrip: "vehicle.detail.kpi_strip",
  tabs: "vehicle.detail.tabs",
  tabNew: "vehicle.detail.tab_new",
} as const;

export const VEHICLE_HELP_TOURS = {
  listIntro: "vehicle.list.intro",
  formCreate: "vehicle.form.create",
  detailIntro: "vehicle.detail.intro",
} as const;
